import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedTaskAction, clearTasksAction, getTasksActions } from '../../redux/actions/tasksActions';

const useFetchTasks = ({ unpaged = false }) => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.tasks?.search);
  const tasks = useSelector((state) => state.tasks?.tasks);
  const loading = useSelector((state) => state.tasks?.loading);

  const fetchTasks = useCallback(async () => {
    await dispatch(getTasksActions(search, unpaged));
  }, [search, unpaged, dispatch]);

  useEffect(() => {
    fetchTasks();
  }, [fetchTasks]);

  useEffect(() => {
    return () => {
      dispatch(clearTasksAction());
      dispatch(clearSelectedTaskAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchTasks();
  };

  return { loading, tasks, refresh };
};

export default useFetchTasks;
